import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Data } from 'signup-constants/signupData/Data';
import { useSignupData } from '../signup-data/useSignupData';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const MessagingCopy = ({
  className,
  message
}) => {
  const {
    data: industry
  } = useSignupData(Data.Industry);
  const industryI18nLabel = industry && industry.toLowerCase().split('-').map(word => word ? word[0].toUpperCase() + word.slice(1) : '').join('');
  const messageWithUserIndustry = `${message}WithUserIndustry.${industryI18nLabel}`;
  const hasIndustryDynamicCopy = isValidI18nKey(messageWithUserIndustry);
  if (!isValidI18nKey(message)) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    className: className,
    message: hasIndustryDynamicCopy ? messageWithUserIndustry : message
  });
};
export default MessagingCopy;